import React, { useContext, useEffect, useRef, useState } from 'react';
import './Exchange.css';
import { toast } from 'react-toast';
import Web3Ctx from '../Context/Web3Ctx';
import { getContract, getDummy721 } from '../Utils/GetContract';
import config from '../../config'
import Navigation from '../Navigation/Navigation';
import CounterBar from '../common/CounterBar';
import BgAnim from '../common/BgAnim';

import { Zoom } from "zoom-next";
import {ethers,BigNumber} from 'ethers';
import { SpinnerDotted } from 'spinners-react';
import terms from './tc';
import ReactMarkdown from 'react-markdown';
import spinnerDust from '../../assets/images/dust-logo-black.png';
import revealCard from '../../assets/images/reveal_card.png';
import blockedCountries from "./blockedCountries";
import axios from 'axios';
import revealVideo from '../../assets/reveal.mp4';
import {  getRemoteImageUrl, getTokenURI } from '../Utils';
import RemoteImage from '../common/RemoteImage';
import {pools} from '../common/DustPools';

const Exchange = (props) => {
    const PUNK_VAULT_ID=0;
    const {onboard,ethersProvider,address} = useContext(Web3Ctx);
    const [poolId,setPoolId] = useState(null);
    const [dustContract,setDustContract] = useState(null);
    const [dust4PunksContract,setDust4PunksContract] = useState(null);
    const [zoom2,setZoom2] = useState(null);
    const [vaultTokenContract,setVaultTokenContract] = useState(null);


    const [dustBalance,setDustBalance] = useState(0);
    const [totalSupply,setTotalSupply] = useState(null);
    const [availableSupply,setAvailableSupply] = useState(null);
    const [vaultName,setVaultName] = useState(null);
    const [itemPrice,setItemPrice] = useState(0);

    const [txInProgress, setTxInProgress]=useState(false);
    const [txHash,setTxHash]=useState(null);
    
    const [showTerms,setShowTerms]=useState(false);

    const [userCountryCode, setUserCountryCode] = useState(null);
    const [countryBlocked, setCountryBlocked] = useState(false);
    const [showRestricted, setShowRestricted] = useState(false);
    const [userHash,setUserHash] = useState(null);
    
    
    const [tokenMeta,setTokenMeta] = useState(null);
    const [videoVisible, setVideoVisible] = useState(false);
    const [punkVisible, setPunkVisible] = useState(false);
    const videoRef = useRef(null);
    const [showFsTc, setShowFsTc] = useState(false);
    const [vaultAddress, setVaultAddress] = useState(null);
    const [vaultToken, setVaultToken] = useState(null);
    const [initDone, setInitDone] = useState(false);

    



    useEffect(()=>{
        const fetchUserCountry = async () => {
            const res = await axios.get(`${config.BASE_SERVER   }/api/location`).catch(e => console.log(e));
            if (res && res.data && res.data.country_code) {
                const countryCode = res.data.country_code;
                //console.log('CC',countryCode);
                setUserCountryCode(countryCode);
            } else {
                toast.error('Unable to determine your country');
            }
        }
        
        fetchUserCountry();

    },[]);

    useEffect(() => {
        if (userCountryCode) {
            const blocked = Object.keys(blockedCountries).includes(userCountryCode);
            //console.log('blocked?',blocked);
            setCountryBlocked(blocked);
        }
    }, [userCountryCode]);

    useEffect(()=>{
        if(ethersProvider){
            setInitDone(false);
            let pid = 0; //default punk
            
            //console.log('props',props);
            if(props.match && props.match.params){
               
                if(props.match.params.poolId!==undefined){
                    pid=Number.parseInt(props.match.params.poolId);
                    if(pid>pools.length-1){
                        pid = -1;
                    }
                }
            }

            setPoolId(pid);

        }
    },[ethersProvider, props]);

    useEffect(()=>{
        const initContract = async ()=>{
            
            let c = await getContract('Dust',ethersProvider);
            if(c){
                setDustContract(c);
            }else{
                toast.error('contract not found');
                return;
            }
            let Zoom2Contract = await getContract('Zoom2', ethersProvider);
            if (Zoom2Contract) {
                setZoom2(Zoom2Contract);
            } else {
                toast.error('Could not initialise Zoom2 Contract');
                return;
            }

            let D4P = await getContract('Dust4Punks', ethersProvider);
            if (D4P) {
                setDust4PunksContract(D4P);
            } else {
                toast.error('Could not initialise D4P Contract');
                return;
            }

        

            /* GET VAULT ADDRESS AND TOKEN */


            const ZoomLibraryInstance = new Zoom();
            let calls = [];
            //Vault address
            const vaultAddress = ZoomLibraryInstance.addCall(
                D4P,
                ["vaultAddress", [poolId]],
                "vaultAddress(uint256) returns (address)"
            );
            calls.push(vaultAddress);

            //Vault token addredd
            const vaultToken = ZoomLibraryInstance.addCall(
                D4P,
                ["vaultToken", [poolId]],
                "vaultToken(uint256) returns (address)"
            );
            calls.push(vaultToken);
        

            const ZoomQueryBinary = ZoomLibraryInstance.getZoomCall();

            //console.log("======== ZOOM CALL START ============" );
            //console.time('zoomCall');
            const combinedResult = await Zoom2Contract.combine( ZoomQueryBinary );
            //console.timeEnd('zoomCall');
            //console.log("======== ZOOM CALL END ==============" );

            ZoomLibraryInstance.resultsToCache( combinedResult, ZoomQueryBinary);

            let va = ZoomLibraryInstance.decodeCall(calls[0]).toString();
            let vt = ZoomLibraryInstance.decodeCall(calls[1]).toString();
            
            let vToken = null;
            if(vt !=="0x0000000000000000000000000000000000000000"){
                vToken = await getDummy721(vt,ethersProvider);
                if (vToken) {
                    setVaultTokenContract(vToken);
                }
            }

            if(vToken===null){
                toast.error('Could not initialise vault token Contract');
                return;
            }

            setVaultAddress(va);
            setVaultToken(vt);

            setInitDone(true);
       }


        if(poolId!==null && poolId > -1){
            console.log('POOL ID CHANGED');
            initContract();
        }
    },[poolId]);

    useEffect(()=>{
        const getData = async()=>{
            if(address){

                const ZoomLibraryInstance = new Zoom({ use_reference_calls: true });
                let calls = [];
                //User's Dust balace
                const balanceCall = ZoomLibraryInstance.addCall(
                    dustContract,
                    ["balanceOf", [address]],
                    "balanceOf(address) returns (uint256)"
                );
                calls.push(balanceCall);

                //Vault price
                const vaultPrice = ZoomLibraryInstance.addCall(
                    dust4PunksContract,
                    ["vaultPrice", [poolId]],
                    "vaultPrice(uint256) returns (uint256)"
                );
                calls.push(vaultPrice);

                const vaultBalance = ZoomLibraryInstance.addCall(
                    vaultTokenContract,
                    ["balanceOf",[vaultAddress]],
                    "balanceOf(address) returns (uint256)"
                );
                calls.push(vaultBalance);
    
                const vName = ZoomLibraryInstance.addCall(
                    dust4PunksContract,
                    ["vaultName",[poolId]],
                    "vaultName(uint256) returns (string)"
                );
                calls.push(vName);
    
                const nHash = ZoomLibraryInstance.addCall(
                    dust4PunksContract,
                    ["numberOfHashes",[address]],
                    "numberOfHashes(address) returns (uint256)"
                );
                calls.push(nHash);


                const ZoomQueryBinary = ZoomLibraryInstance.getZoomCall();

                console.log("======== ZOOM CALL START ============" );
                console.time('zoomCall');
                const combinedResult = await zoom2.combine( ZoomQueryBinary );
                console.timeEnd('zoomCall');
                console.log("======== ZOOM CALL END ==============" );
    
                ZoomLibraryInstance.resultsToCache( combinedResult, ZoomQueryBinary);
 
                let b = ZoomLibraryInstance.decodeCall(calls[0]).toString();
                let ip = ZoomLibraryInstance.decodeCall(calls[1]).toString();
                let vb = ZoomLibraryInstance.decodeCall(calls[2]).toString(); 
                let vn = ZoomLibraryInstance.decodeCall(calls[3]).toString(); 
                let nh = ZoomLibraryInstance.decodeCall(calls[4]).toString(); 

                setDustBalance(b);
                setItemPrice(ip);
                setAvailableSupply(vb);
                setVaultName(vn);

                //setUserHash('0x51b6b3e50eca55a72d4918202aa8287f9a04853c94a862658a899b2901fdf71a')
                
                //console.log('numofhashes',nh, typeof nh);
                
                if(Number.parseInt(nh)>0){
                    /* const ZoomLib = new Zoom();
                    let c = [];
                    for(let i=0;i<nh;i++){

                        const uh = ZoomLib.addCall(
                            dust4PunksContract,
                            ["userhashes",[address,i]],
                            "userhashes(address,uint256) returns (bytes32)"
                        );
                        c.push(uh);

                    }
                    const ZQB = ZoomLib.getZoomCall();

                    //console.log("======== ZOOM CALL START ============" );
                    //console.time('zoomCall');
                    const combinedResult = await zoom2.combine( ZQB );
                    //console.timeEnd('zoomCall');
                    //console.log("======== ZOOM CALL END ==============" );
        
                    ZoomLib.resultsToCache( combinedResult, ZQB);
                    let userHashes = []
                    for(let j=0;j<nh;j++){
                        let b = ZoomLib.decodeCall(c[j]).toString();
                        userHashes.push(b);
                    }

                    console.log(userHashes);

 */
                    let storedHash = localStorage.getItem(pools[poolId].type);

                    if(storedHash){
                        setUserHash(storedHash);
                        setTxHash(null);
                    }else{
                        setUserHash(null);
                    }

    /* 
                    let lastUserHash = await dust4PunksContract.userhashes(address,Number.parseInt(nh)-1).catch(e=>{console.log(e)});
                    
                    //console.log('Last hash:',lastUserHash);

                    if(lastUserHash){
                        let id = await dust4PunksContract.redeemedTokenId(lastUserHash).catch(e=>{console.log(e)});
                       // console.log('tokeniD',id);
                        if(Number.parseInt(id._hex, 16)===0){
                            setUserHash(lastUserHash)
                        }else{
                            setTxHash(null);
                        }
                    } */
                }
            }
            
            
            
            //init done, lets see if there is a tx in progress...
            let tx = localStorage.getItem(pools[poolId].type+'_tx');
            if(tx){
                setTxHash(tx);
            }else{
                setTxHash(null);
            }
        }

        if(initDone && address && dustContract && zoom2 && dust4PunksContract && vaultTokenContract && poolId!==null && poolId > -1 && vaultAddress !==null){
           console.log('getData');
            getData();
        }

    },[dustContract,zoom2,dust4PunksContract,vaultTokenContract,address,poolId,vaultAddress,initDone ]);


    useEffect(()=>{
        const waitForTx = async ()=>{
            setTxInProgress(true);
            let tr = await ethersProvider.waitForTransaction(txHash,1,30000).catch(e=>{console.log(e);});
            if(tr){
                if(tr.status>0){
                    toast.success('Transaction sent.');

                    //console.log('wait for punks');
                }
            }
            
            localStorage.removeItem(pools[poolId].type+'_tx');;
            setTxInProgress(false);

            let b = await dustContract.balanceOf(address).catch(e=>{console.log(e)});
            if(b){
                setDustBalance(b);
            }

            let numOfHashes = await dust4PunksContract.numberOfHashes(address).catch(e=>{console.log(e)})
            
            
            if(numOfHashes ){
                let lastUserHash = await dust4PunksContract.userhashes(address,Number(numOfHashes)-1).catch(e=>{console.log(e)})
                
                //console.log('Last hash:',lastUserHash);
                //TODO: store the hash, wait 4 punk...
                if(lastUserHash){
                    setTxHash(null);
                    setUserHash(lastUserHash);
                    localStorage.setItem(pools[poolId].type,lastUserHash);
                }

                /* const userHashes={
                    0: [0x1],
                    1: [],
                    2: [0x22],
                    3: [0x333],
                    4: []
                } */
            
            }
            setTxHash(null);
        }

        if(txHash){
            waitForTx();
        }
    },[txHash]);


    useEffect(()=>{
        if(userHash){
            let intervalId = setInterval(async()=>{


            let id = await dust4PunksContract.redeemedTokenId(userHash).catch(e=>{console.log(e)});
                console.log('redeemed id',id);
            if(Number.parseInt(id._hex, 16)){
                localStorage.removeItem(pools[poolId].type);
                
                if(vaultTokenContract){

                    let tUri = await vaultTokenContract.tokenURI(id).catch(e=>{console.log(e)});

                  //  console.log('uri',tUri);
                    let meta = await getTokenURI(tUri);

                    if(meta){
                        setTokenMeta(meta);
                    }else{
                        //meebit cors hack :/

                        if(poolId===1){
                            //if meebit...
                           let id = tUri.split('/').pop();
                           let image = "https://meebits.larvalabs.com/meebitimages/characterimage?index=****&type=full&imageType=jpg".replace('****',id);
                           setTokenMeta({id,image});
                        }


                    }


                  //  console.log(meta);
                }

                clearInterval(intervalId);
                console.log(id);
            }else{
                console.log('no id yet',id);
            }


            },10000);

            
            return () => {
                if (intervalId) {
                    clearInterval(intervalId);
                }
            };
        }


    },[userHash]);

    useEffect(()=>{
        if(tokenMeta){
            try{
                const img = new Image();
                img.src=getRemoteImageUrl(tokenMeta.image);
            }catch (e){
                console.log('errror',e);
            }

            videoRef.current.play();
            setVideoVisible(true);
            //!
            setTimeout(()=>{videoFinished()},5000);
        }
    },[tokenMeta]);

    const videoFinished = ()=>{
        setPunkVisible(true);
        setVideoVisible(false);
   }



    const handleConnect = async () => {
        if (onboard) {
            onboard.walletReset();
            const selected = await onboard.walletSelect().catch((e)=>{console.log(e)});
            console.log('selected', selected);
            if(selected){
               await  onboard.walletCheck();
            }
        }
    }

    const doTheExchange = async () => {

        
        if(countryBlocked){
            setShowRestricted(true);
        }else{
            let b = Number.parseFloat(ethers.utils.formatEther(dustBalance));
            let p = Number.parseFloat(ethers.utils.formatEther(itemPrice));
            
            if(b < p){
                toast.warn('Your Dust balance is lower than the item price.');
                return
            }
            setShowTerms(true);
        }
    }


    const _doTheExchange = async () => {
        setTxInProgress(true);

        //const data="0x0000000000000000000000000000000000000000000000000000000000000000";
        const data=ethers.utils.hexZeroPad(poolId,32);


        let dc = dustContract.connect(ethersProvider.getSigner());
        let gasLimit= BigNumber.from(550000);// await dc.estimateGas.send(dust4PunksContract.address,itemPrice,data).catch(e =>{toast.error(e.error.message)});
       // console.log('GASLIMIT',gasLimit);
        
        if(gasLimit){

            let tx = null;
            tx = await dc.send(dust4PunksContract.address,itemPrice,data,{gasLimit}).catch(e =>{toast.error(e.message)});

            if(tx){
                localStorage.setItem(pools[poolId].type+'_tx',tx.hash);
                setTxHash(tx.hash);
                
            }else{
                setTxInProgress(false);
            }
        }else{
            setTxInProgress(false);
        }

    }


    const goHome=()=>{
        props.history.push('/');
    }

    if(poolId===null){


        return (
            <>loading...</>
        );
    }



    return (
        <>
            <Navigation mode="light"/>


            {poolId<0?
                <div className="container mt-5 h-100 home pb-5">

                    <div className="row">
                        <div className="col-md-8 text-center mx-auto">
                             <h3>invalid pool id</h3>
                             <button className="btn btn-pool  outline black mt-5 mr-1" onClick={()=>props.history.push('/')}>back</button>
                        </div>
                    </div>
                </div>
            :
            <div className="container mt-5 h-100 home pb-5">

                <div className="row">
                    <div className="col-md-8 text-center mx-auto">
                        <h1 className="title-black">{pools[poolId].poolName}</h1>
                        <p className="mt-5 mx-auto">{pools[poolId].poolInfo}</p>
                    </div>
                </div>

                <div className="row mt-5">
                    <div className="col-md-8 mx-auto">

                        <div className="row exchange">
                            <div className="col-md-4 image-column">
                                <div className={`xchange-image ${pools[poolId].type} mb-4`}></div>

                                <div className="hexa a-right">
                                    <h4 className="title">view all<br/>from pool</h4>
                                    <a className="hex-image" href={pools[poolId].poolUrl} target="_blank" rel="noreferrer">
                                        <span className={pools[poolId].poolIcon}></span>
                                    </a>
                                </div>
                            </div>
                            <div className="col-md-8">
                                <p className="labels mt-0 mb-0">Counter:</p>
                                <CounterBar value={availableSupply} maxValue={pools[poolId].totalSupply} />

                                <p className="labels mt-2 mb-0">Your Dust balace:</p>
                                <p className="mt-0 mb-0">{Number(ethers.utils.formatEther(dustBalance)).toLocaleString()} D</p>
                                
                                <p className="labels mt-2 mb-0">Price:</p>
                                <p className="mt-0 ">{Number(ethers.utils.formatEther(itemPrice)).toLocaleString()} D</p>


                                <p className="labels mt-2 mb-0">Information:</p>
                                
                                <p className="descr mt-0 mb-5">{pools[poolId].tokenInfo.replace('*****',Number(ethers.utils.formatEther(itemPrice)).toLocaleString())} <span className="fake-link" onClick={()=>setShowFsTc(true)}>Terms and Conditions</span> apply.</p>
                            
                                <button className="btn btn-pool  outline black mr-1" onClick={()=>props.history.push('/')}>back</button>
                                
                                {address?
                                <button className="btn btn-pool  black outline mr-auto mt-auto" onClick={()=>doTheExchange()} disabled={txInProgress}>
                                    {txInProgress&&<SpinnerDotted className="mr-1" enabled={true} size={22} thickness={160} speed={200} color="#fff" /> }
                                    exchange now
                                </button>
                                :
                                <button className="btn btn-pool black outline mr-auto mt-auto" onClick={()=>handleConnect()}>connect to wallet</button>
                                }
                            </div>


                        </div>






                    </div>

                </div>

                <div className="row mt-5 pb-5">
                    <div className="col-md-7 text-center mx-auto text-halfbright">
                        <p className="mt-5 mx-auto small-text">Ether Cards makes no representation, warranty, or undertaking, express or implied, as to the accuracy, reliability, completeness, or reasonableness of the information in this roadmap. Any assumptions, opinions, and details expressed in any Ether Cards blog or community posts constitute Ether Card’s judgment as of the date thereof and are subject to change without notice. Any projections or claims contained in the information are based on a number of assumptions including, but not limited to market conditions and the current status of Ether Cards, and there can be no guarantee that any projected outcomes will be achieved.</p>
                    </div>
                </div>
            </div>
            }
            
            {(txHash||userHash) && 
                <div className="tx-in-progress d-flex flex-column text-center justify-content-top px-3">
                    
                {userHash?
                    <>
                        <>

                        {punkVisible?
                        <div className="text-center mt-5 punk-container">
                            

                            <div className="row mt-4">

                                <div className=" col-md-4 mx-auto">


                                    <div className="row">
                                        <div className="col-md-5 mx-auto">
                                            <div className="nft-card">
                                                <RemoteImage src={tokenMeta.image} />
                                            </div>
                                        </div>
                                    </div>



                                    <h3 className="title-black mt-4">congratulations</h3>
                                    <div className="px-5 my-3"><ReactMarkdown children={pools[poolId].congratsText}/></div>
                                    <button className="btn btn-pool black outline mr-1 my-1" onClick={goHome}>back to pool</button>
                                    <a className="btn btn-pool black outline ml-1 my-1" href="https://explorer.ether.cards/#/wallet"  target="_blank" rel="noreferrer">view in wallet</a>

                                </div>
                            </div>
                        </div>
                        :
                        <div className=" pt-5"> 
                            <div className="reveal-container mb-0 mt-0">
                                <img src={revealCard} alt="dust" />
                            </div>

                            <h2 className="title-black mt-n4">Vrf initialised</h2>
                            <div className="row mt-4">
                                <div className=" col-md-4 mx-auto">
                                    <p className="descr">Transaction was successful. Chainlink’s VRF will now pick a random NFT from the vault. Please be patient as this process might take several minutes.</p>

                                </div>
                            </div>
                        </div>
                        }

                        </>

                        <div className={`video-box d-flex flex-column justify-content-center ${videoVisible&&'visible'}`}>
                            <video
                                    ref={videoRef}
                                    onEnded={videoFinished}
                                    playsInline
                                    className="w-100"
                                    src={revealVideo} 
                            /> 
                        </div>
                    </>

                    :
                    <div className="mt-5 pt-5"> 
                        <div className="spinner-container my-5">
                            <img src={spinnerDust} alt="dust" />
                        </div>

                        <h2 className="title-black mt-2">Waiting for transaction</h2>
                        <p className="descr mt-4">Please wait until the transaction is complete.<br/>You can check the status on  <a className="es-link" href={config.ETHERSCAN+'/tx/'+txHash} target="_blank" rel="noreferrer">Etherscan.</a></p>
                    </div>
                } 


                </div>
            }







            
            {showTerms&&<div className="modal d-flex align-items-center">
                <div className="row w-100">
                    <div className="col-md-6 mx-auto">

                        <div className="tc-box text-center">
                                <h4 className="mx-auto  px-5 mb-4 title-black">TERMS AND CONDITIONS</h4>
                                <div className="tc-modal-body text-justify"  dangerouslySetInnerHTML={{__html: pools[poolId].terms}}>
                                    {/* <ReactMarkdown children={terms}/> */}
                                </div>
                                <div className="d-flex  mt-5 mb-3">
                                    <button className="btn btn-pool white outline mr-1 ml-auto" onClick={()=>setShowTerms(false)}>cancel</button>
                                    <button className="btn btn-pool filled white ml-1 mr-auto" onClick={()=>{setShowTerms(false);_doTheExchange()}}>accept</button>
                                </div>
                        </div>
                    </div>
                </div>
            </div>}


            {showFsTc&&<div className="modal d-flex align-items-center fs">
                <div className="row w-100">
                    <div className="col-md-6 mx-auto">

                        <div className="tc-box fs text-center">
                                <h4 className="mx-auto  px-5 mb-4 title-black">TERMS AND CONDITIONS</h4>
                                <div className="tc-modal-body text-justify" dangerouslySetInnerHTML={{__html: pools[poolId].terms}}>
                                   {/*  <ReactMarkdown children={terms}/> */}
                                </div>
                                <div className="d-flex  mt-5 mb-3">
                                    <button className="btn btn-pool white outline mr-1 ml-auto" onClick={()=>setShowFsTc(false)}>back</button>
                                </div>
                        </div>
                    </div>
                </div>
                <h1 className="tc-close" onClick={()=>{setShowFsTc(false)}}>X</h1>
            </div>}

            {showRestricted&&<div className="modal d-flex align-items-center">
                <div className="row">
                    <div className="col-md-6 mx-auto">

                        <div className="tc-box text-center">
                                <h4 className="mx-auto  px-5 mb-4 title-black">Restricted region</h4>
                                <div className="tc-modal-body row">
                                {Object.values(blockedCountries).map((country) => {
                                return (
                                    <div className="col-md-4 text-center">
                                        {country}
                                    </div>
                                );
                                })}
                                <p className="mt-4">For more information or any questions, please contact a moderator in the 
                                    &nbsp;<a className="discord-link" href="https://discord.com/channels/807946276079140875/811206939701936129" target="_blank" rel="noreferrer">Ether Cards Discord</a> Channel.
                                </p>
                                    
                                </div>
                                <div className="mt-3 mb-0">
                                    <button className="btn btn-pool white outline mx-auto" onClick={()=>setShowRestricted(false)}>back</button>
                                    
                                </div>
                        </div>
                    </div>
                </div>
            </div>}

            <BgAnim/>


        </>
    );

}

export default Exchange;